import { Get } from './Koneksi';

export function getList(jenisData, cariData) {
	
	let frmData = [];
	let link = ''
	if(cariData){
		link = 'get-model/'+jenisData+'?q='+cariData
	}
	else{
		link = 'get-model/'+jenisData
	}
	Get(link, null, (data) => {

		if(jenisData === 'penduduk' || jenisData === 'penduduk-kk'){
			data.forEach((dt) => {
				frmData.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
			});
		}
		else if(jenisData === 'perangkat'){
			data.forEach((dt) => {
				frmData.push({ value: dt.uuid, label: dt.data_penduduk.nama + ' (' + dt.data_jabatan.nama + ')' });
			});
		}
		else{
			data.forEach((dt) => {
				frmData.push({ value: dt.uuid, label: dt.nama });
			});
		}
		
	});

	return frmData;
}

export function contactPerson() {
	
	let wa = 'https://wa.me/6285780594264';
	let nomor_hp = '6285780594264';

	let contact={
		wa: wa,
		nomor_hp: nomor_hp
	}
	
	return contact;
}